const url = {
index:'/api/index/index' ,//首页信息展示
index_links:'/api/index/links' ,//首页友情链接
index_point:'/api/index/point' ,//首页重点推荐
index_world500:'/api/index/world500' ,//首页世界500强
index_china500:'/api/index/china500' ,//首页中国500强
index_unicorn:'/api/index/unicorn' ,//首页独角兽
index_webcon:'/api/index/webcon' ,//首页其他信息
send:'/api/mistaken/send',//首页网址纠错发送邮件接口
updatead:'/api/config/updatead',
//登陆相关接口
//获取验证码接口/验证码刷新
captcha1:'/api/auth/captcha1',//应聘者
captcha2:'/api/auth/captcha2',//企业用户
captcha3:'/api/auth/captcha3',//管理者
login:'/api/auth/login',//登录接口
loginout:'/api/auth/loginout',//退出登录接口
auth_revise:'/api/auth/revise',//修改密码

//上传相关接口
upload:'/api/attachment/upload',//单图片上传
uploadimg:'/api/attachment/uploadimg',//多图上传
//平台管理员首页接口
//网站logo、以及下方截图处修改接口
config_upload:'/api/config/upload',//修改logo
update:'/api/config/update',//平台管理员最底下纠错及邮箱
links_index:'/api/links/index',//友情链接列表
save:'/api/links/save',//添加友情链接
links_update:'/api/links/update',//修改友情链接
links_delete:'/api/links/delete',//删除友情链接

//重点推荐相关接口
recommend_cmylist:'/api/recommend/cmylist',//获取未推荐的企业列表
recommend_index:'/api/recommend/index',//重点推荐列表
recommend_save:'/api/recommend/save',//添加重点推荐企业
recommend_update:'/api/recommend/update',//修改重点推荐企业
recommend_delete:'/api/recommend/delete',//删除重点推荐企业

//世界500/中国500行业相关接口
industry_save:'/api/industry/save',//添加行业
industry_update:'/api/industry/update',//修改行业
industry_delete:'/api/industry/delete',//删除行业

//世界500强相关接口
world500_index:'/api/world500/index',//世界500强列表
world500_save:'/api/world500/save',//添加世界500强企业
world500_update:'/api/world500/update',//修改世界500强企业
world500_delete:'/api/world500/delete',//删除世界500强企业

//中国500强相关接口
china500_index:'/api/china500/index',//中国500强列表
china500_save:'/api/china500/save',//添加中国500强企业
china500_update:'/api/china500/update',//修改中国500强企业
china500_delete:'/api/china500/delete',//删除中国500强企业

//最具潜力相关接口
potential_index:'/api/potential/index',//最具潜力列表
potential_save:'/api/potential/save',//添加最具潜力企业
potential_update:'/api/potential/update',//修改最具潜力企业
potential_delete:'/api/potential/delete',//删除潜力企业

//平台管理员-企业账户管理
cmy_accountSave:'/api/cmy_account/save',//添加企业账户
cmy_accountUpdate:'/api/cmy_account/update',//修改企业账户
cmy_accountSuspend:'/api/cmy_account/suspend',//暂停使用
cmy_accountTopcmy:'/api/cmy_account/topcmy',//获取母公司列表
cmy_accountIndex:'/api/cmy_account/index',//企业账户列表/筛选列表
index_log_read:'/api/index_log/read',//查看使用日志2020/4/13

datarecord_index:'/api/datarecord/index',//数据统计接口
clicks_read:'/api/clicks/read',//获取点击次数
clicks_clicks:'/api/clicks/clicks',//当天访问量

//企业登录相关接口
read:'/api/cmyconfig/read',//企业登录-获取网页配置信息接口
cmyconfig_update:'/api/cmyconfig/update',//企业登录-修改网页配置
cmyed_update:'/api/cmyed/update',//企业登录-设置编辑企业风采
cmyxy_update:'/api/cmyxy/update',//企业登录-设置编辑校园招聘
cmyed_read:'/api/cmyed/read',//企业登录-获取企业风采
cmyxy_read:'/api/cmyxy/read',//企业登录-获取校园招聘

//企业登录-职类相关接口
jobtype_save:'/api/jobtype/save',//添加职类
jobtype_read:'/api/jobtype/read',//获取职类信息
jobtype_update:'/api/jobtype/update',//编辑职类
jobtype_topjob:'/api/jobtype/topjob',//置顶职类
jobtype_endjob:'/api/jobtype/endjob',//结束发布
jobtype_index:'/api/jobtype/index',//企业登录-获取职类列表
jobtype_jobtypefolw:'/api/jobtype/jobtypefolw',//查看关注
jobposn_deliver:'/api/jobposn/deliver',//查看简历
//企业登录-职位相关接口
jobposn_save:'/api/jobposn/save',//添加职位
jobposn_read:'/api/jobposn/read',//获取职位信息
jobposn_update:'/api/jobposn/update',//编辑职位
jobposn_topjob:'/api/jobposn/topjob',//置顶职类
jobposn_endjob:'/api/jobposn/endjob',//结束发布
jobposn_branlist:'/api/jobposn/branlist',//列表页获取企业所属部门/分子公司
jobposn_index:'/api/jobposn/index',//获取职位列表（筛选项）接口
jobtype_flowread:'api/jobtype/flowread',//关注回显


//省市区相关接口2020/4/14
city_province:'/api/city/province',//获取全部省份（包含直辖市）2020/4/14
city_city:'/api/city/city',//获取市2020/4/14
city_area:'/api/city/area',//获取区2020/4/14
city_cityaz:'/api/city/cityaz',//获取带拼音的市列表2020/04/16
city_cityazzz:'/api/city/cityazzz',//单独获取市2020/4/14
city_cityp:'/api/city/cityp',//单独获取市2020/5/18

//应聘者相关接口
resume_read:'/api/resume/read',//获取简历信息2020/04/14
resume_gain:'/api/resume/gain',//获取基本信息、获取求职意向、获取胜任能力、获取自我评价、获取附加信息接口
//修改简历2020/04/15（手机、pc通用）
resume_update:'/api/resume/update',//修改基本信息、修改求职意向、修改胜任能力、修改自我评价、修改附加信息接口
resume_filling:'/api/resume/filling',//简历状态

education_update:'/api/education/update',//修改教育经历2020/04/16
education_delete:'/api/education/delete',//删除教育经历2020/04/16
education_save:'/api/education/save',//添加教育经历2020/04/16
education_read:'/api/education/read',//获取单个教育经历信息2020/04/16
resume_edupc:'/api/resume/edupc',//获取教育经历列表（pc）2020/04/16
resume_gongzuo:'/api/resume/gongzuo',//获取简历-工作经历（pc、手机）2020/04/16
resume_xiangmu:'/api/resume/xiangmu',//获取简历-项目经历（pc、手机）2020/04/16
work_ex_save:'/api/work_ex/save',//添加工作经历2020/04/16
work_ex_read:'/api/work_ex/read',//获取单个工作经历2020/04/16
work_ex_update:'/api/work_ex/update',//修改工作经历2020/04/16
work_ex_delete:'/api/work_ex/delete',//删除工作经历
item_ex_save:'/api/item_ex/save',//添加项目经历2020/04/16
item_ex_update:'/api/item_ex/update',//修改项目经历2020/04/16
item_ex_read:'/api/item_ex/read',//获取单个项目经历2020/04/16
item_ex_delete:'/api/item_ex/delete',//删除项目经历2020/04/16

mistaken_relay:'/api/mistaken/relay',//转发简历
qrocde_readqrcode:'api/qrocde/readqrcode',//我要分享生成二维码

word_read:'api/word/read',//word文档下载
cmy_account_cmid:'api/cmy_account/cmid',//根据url获取企业接口
}



export default {
    url
}


// WEBPACK FOOTER //
// ./src/assets/api/url.js